import { useQuery } from '@tanstack/react-query';

import { GHADiscountSummaryFilters, getGHADiscountSummary } from '~/services/ConnectionGoogleService';

export const ghaDiscountSummaryQueryKeys = {
  all: ['ghaDiscountSummary'] as const,
  summary: (filters: GHADiscountSummaryFilters) => [...ghaDiscountSummaryQueryKeys.all, filters] as const,
};

export function useGHADiscountSummary(filters: GHADiscountSummaryFilters = {}) {
  return useQuery({
    queryKey: ghaDiscountSummaryQueryKeys.summary(filters),
    queryFn: async ({ signal }) => {
      const response = await getGHADiscountSummary(filters, { signal });
      return response.result;
    },
  });
}
